import cn from "classnames";
import styles from "./styles/TextEditor.module.scss";

export const getContainerClassNames = (hideToolbar?: boolean) => {
  return cn(styles.container, hideToolbar && styles.hideToolbar);
};